import React from 'react';
import { ReactFlowProvider } from 'reactflow';
import JourneyMapCanvasInner from './JourneyMapCanvasInner';
import {
  CANVAS_DEFAULT_HEIGHT,
  CANVAS_DEFAULT_WIDTH,
} from './journeyMapCanvasConstants';
import { SectionDelimiterRecord } from './journeyMapCanvasTypes';

type Props = {
  backgroundImageUrl?: string | null;
  sectionDelimiters?: SectionDelimiterRecord[];
  canvasWidth?: number;
  canvasHeight?: number;
};

export default function JourneyMapCanvas({
                                           backgroundImageUrl = null,
                                           sectionDelimiters = [],
                                           canvasWidth = CANVAS_DEFAULT_WIDTH,
                                           canvasHeight = CANVAS_DEFAULT_HEIGHT,
                                         }: Props) {
  return (
    <ReactFlowProvider>
      <JourneyMapCanvasInner
        backgroundImageUrl={backgroundImageUrl}
        sectionDelimiters={sectionDelimiters}
        canvasWidth={canvasWidth}
        canvasHeight={canvasHeight}
      />
    </ReactFlowProvider>
  );
}